import { useCallback, useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import GatewayView from "@/components/GatewayView";
import PortalView from "@/components/PortalView";
import BrandLoader from "@/components/BrandLoader";
import CookieBanner from "@/components/CookieBanner";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";

const parseRoute = () => {
  const h = window.location.hash.replace(/^#\/?/, "");
  if (h === "commercial" || h === "residential") return h;
  return "gateway";
};

function App() {
  const [view, setView] = useState(parseRoute);
  const [loading, setLoading] = useState(true);
  useLenis();

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(t);
  }, []);

  const navigate = useCallback((v) => {
    window.location.hash = v === "gateway" ? "/" : `/${v}`;
  }, []);

  useEffect(() => {
    const onHash = () => {
      setView(parseRoute());
      window.scrollTo({ top: 0, behavior: "instant" });
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  return (
    <div className="grain min-h-screen bg-[#0B0F19] font-body text-white">
      <AnimatePresence>{loading && <BrandLoader />}</AnimatePresence>

      {!loading &&
        (view === "gateway" ? (
          <GatewayView onSelect={navigate} />
        ) : (
          <PortalView division={view} onHome={() => navigate("gateway")} />
        ))}

      <WhatsAppButton />
      <CookieBanner />
      <Toaster position="bottom-center" theme="dark" richColors />
    </div>
  );
}

export default App;
